import styled from "styled-components";

export const DrawerFooter = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  .btn {
    height: 40px;
    width: 140px;
  }
  .btnCancel {
    height: 40px;
    width: 140px;
    border: 1px solid ${(props) => props.theme.colors.manatee};
  }
`;
